import React, { useEffect, useState } from "react";
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { toast } from "react-toastify";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
}));

const PerfisList = ({ onEdit, onDelete }) => {
  const classes = useStyles();
  const [perfis, setPerfis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [perfilToDelete, setPerfilToDelete] = useState(null);

  useEffect(() => {
    async function fetchPerfis() {
      try {
        const { data } = await api.get("/profiles");
        setPerfis(data);
      } catch (err) {
        setPerfis([]);
      } finally {
        setLoading(false);
      }
    }
    fetchPerfis();
  }, []);

  const handleDeleteClick = (perfil) => {
    if (perfil.perf_name.toLowerCase() === "admin") {
      return;
    }
    setPerfilToDelete(perfil);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (perfilToDelete?.perf_name?.toLowerCase() === "admin") {
      setConfirmOpen(false);
      setPerfilToDelete(null);
      return;
    }
    try {
      await api.delete(`/profiles/${perfilToDelete.id}`);
      toast.success(i18n.t("profiles.toasts.deleted"));
      setPerfis((prev) => prev.filter((p) => p.id !== perfilToDelete.id));
      if (onDelete) onDelete(perfilToDelete);
    } catch (err) {
      toast.error(i18n.t("profiles.toasts.deleteError"));
    } finally {
      setConfirmOpen(false);
      setPerfilToDelete(null);
    }
  };

  const handleEditClick = (perfil) => {
    if (perfil.perf_name.toLowerCase() === "admin") {
      return;
    }
    if (onEdit) onEdit(perfil);
  };

  if (loading) return <div>{i18n.t("common.loading")}</div>;

  return (
    <>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">{i18n.t("common.name")}</TableCell>
            <TableCell align="center">{i18n.t("common.actions")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {perfis.map((perfil) => (
            <TableRow key={perfil.id}>
              <TableCell align="center">{perfil.id}</TableCell>
              <TableCell align="center">{perfil.perf_name}</TableCell>
              <TableCell align="center">
                <IconButton size="small" onClick={() => handleEditClick(perfil)} disabled={perfil.perf_name.toLowerCase() === "admin"}>
                  <EditIcon />
                </IconButton>
                <IconButton size="small" onClick={() => handleDeleteClick(perfil)} disabled={perfil.perf_name.toLowerCase() === "admin"}>
                  <DeleteOutlineIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>{i18n.t("profiles.confirmDelete.title")}</DialogTitle>
        <DialogContent>
          {i18n.t("profiles.confirmDelete.message", { name: perfilToDelete?.perf_name })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="secondary" variant="outlined">
            {i18n.t("common.cancel")}
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" variant="contained">
            {i18n.t("common.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PerfisList;
